import { API_BASE_URL } from "../lib/app-config.js";

export interface Me {
  email: string;
  approved: boolean;
  admin: boolean;
}

let mePromise: Promise<Me | null> | null = null;

export function loadMe(): Promise<Me | null> {
  if (!mePromise) {
    mePromise = (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/me`, { credentials: "include" });
        if (!res.ok) return null;
        return (await res.json()) as Me;
      } catch {
        return null;
      }
    })();
  }
  return mePromise;
}

export function clearMe(): void {
  mePromise = null;
}
